'use strict';

exports.__esModule = true;
exports['default'] = renderComponent;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _validators = require('../../utils/validators');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function renderComponent(Component) {
  return function (target) {
    (0, _validators.validateClass)(target, 'renderComponent');

    // eslint-disable-next-line
    target.prototype.render = function render() {
      return _react2['default'].createElement(Component, this.props);
    };
  };
}